import React, { useState, useRef, useEffect } from 'react';
import pageData from '../../../common/branch/data.json';
import styles from './index.module.less';

function BranchPC() {
  const [activeIndex, setActiveIndex] = useState(0);
  const committees = pageData[0]?.value;
  const committeeRefs = useRef([]) as React.MutableRefObject<any[]>;

  // 初始化引用数组
  useEffect(() => {
    committeeRefs.current = committeeRefs.current.slice(0, committees.length);
  }, [committees]);

  // 点击切换专委会
  const handleTabClick = (index) => {
    setActiveIndex(index);
    if (committeeRefs.current[index]) {
      committeeRefs.current[index].scrollIntoView({ behavior: 'smooth' });
    }
  };

  // 专委会导航项组件
  const CommitteeNavItem = ({ icon, name, isActive, onClick }) => (
    <div
      className={`${styles['branch__nav-item']} ${
        isActive ? styles['branch__nav-item--active'] : ''
      }`}
      onClick={onClick}
    >
      <img className={styles['branch__nav-item__icon']} src={icon} alt={name} />
      <span className={styles['branch__nav-item__name']}>{name}</span>
    </div>
  );

  // 渲染专委会详情
  const renderCommitteeDetail = (committee, index) => {
    if (!committee) return null;

    return (
      <div
        className={styles['branch__committee']}
        ref={(el) => (committeeRefs.current[index] = el)}
        id={`committee-${index}`}
      >
        <div className={styles['branch__committee__header']}>
          <div className={styles['branch__committee__icon']}>
            <img src={committee.icon} alt={committee.committee} />
          </div>
          <div className={styles['branch__committee__title']}>
            <span className={styles['branch__committee__title__main']}>{committee.committee}</span>
            <span className={styles['branch__committee__title__sub']}>
              &nbsp;&nbsp;{committee.committeeEng}
            </span>
          </div>
        </div>

        <div className={styles['branch__committee__profile']}>{committee.profile}</div>

        <div className={styles['branch__committee__members']}>
          <div className={styles['branch__committee__row']}>
            <div className={styles['branch__position']}>主任委员</div>
            <div className={styles['branch__member__name']}>{committee.name}</div>
            <div className={styles['branch__member__title']}>
              {Array.isArray(committee.appellation)
                ? committee.appellation.join('，')
                : committee.appellation}
            </div>
          </div>

          {committee.viceChairpersons && committee.viceChairpersons.length > 0 && (
            <div className={styles['branch__committee__row']}>
              <div className={styles['branch__position']}>副主任委员</div>
              <div>
                {committee.viceChairpersons.map((viceChair, idx) => (
                  <div key={idx} className={styles['branch__member']}>
                    <div className={styles['branch__member__name']}>{viceChair.name}</div>
                    <div className={styles['branch__member__title']}>
                      {Array.isArray(viceChair.appellation)
                        ? viceChair.appellation.join('，')
                        : viceChair.appellation}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {committee.secretary && (
            <div className={styles['branch__committee__row']}>
              <div className={styles['branch__position']}>秘书长</div>
              <div className={styles['branch__member__name']}>{committee.secretary.name}</div>
              <div className={styles['branch__member__title']}>
                {Array.isArray(committee.secretary.appellation)
                  ? committee.secretary.appellation.join('，')
                  : committee.secretary.appellation}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  // 渲染导航
  const renderCommitteeNav = () => {
    const rows = [] as any;
    for (let i = 0; i < committees.length; i += 3) {
      rows.push(committees.slice(i, i + 3));
    }

    return (
      <div className={styles['branch__nav']}>
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className={styles['branch__nav__row']}>
            {row.map((committee, colIndex) => {
              const index = rowIndex * 3 + colIndex;
              return (
                <CommitteeNavItem
                  key={index}
                  icon={committee.icon}
                  name={committee.committee}
                  isActive={activeIndex === index}
                  onClick={() => handleTabClick(index)}
                />
              );
            })}
          </div>
        ))}
      </div>
    );
  };

  return (
    <section className={styles.branch}>
      <div className={styles.branch__container}>
        <div className={styles['title']}>九大专委会</div>
        {renderCommitteeNav()}
        <div className={styles['branch__content']}>
          {committees.map((committee, index) => renderCommitteeDetail(committee, index))}
        </div>
      </div>
    </section>
  );
}

export default BranchPC;
